import React, {useEffect, useState} from 'react';
import {Row, Col, CardBody, Card, Container, Label, Button} from 'reactstrap';
import {FormProvider, useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import {SweetAlert} from '../../components/Common/SweetAlert';

import {registerUser, registerUserFailed} from '../../store/actions';
import logoImg from '../../assets/images/logo-brother.svg';
import ListDealers from '../../components/Lists/ListDealers';

const positions = [
  {label: 'Engineer', value: 'Engineer'},
  {label: 'Sales', value: 'Sales'},
];

const Register = () => {
  // const [selectedDealer, setSelectedDealer] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {user, registrationError} = useSelector((state) => state.Account);

  const form = useForm();
  const {register, handleSubmit, watch, formState: {errors}} = form;
  const password = watch('password');

  const onSubmit = (data) => {
    setIsLoading(true);

    const userData = {
      firstname: data.firstname,
      lastname: data.lastname,
      position: data.position,
      dealer_id: data.dealer,
      email: data.email,
      phone: data.phone,
      password: data.password,
      password_confirmation: data.password_confirmation,
    };

    dispatch(registerUser(userData));
  };

  useEffect(() => {
    dispatch(registerUserFailed(''));
  }, [dispatch]);

  useEffect(() => {
    if (user && !registrationError) {
      setSuccessMsg(true);
    } else if (registrationError) {
      setIsLoading(false);
      const firstError = Object.values(registrationError.errors || {})[0];
      setErrorMsg(firstError);
    }
  }, [user, registrationError]);

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        {errorMsg && (
          <SweetAlert
            title="Error!"
            danger
            showConfirm
            confirmBtnBsStyle="danger"
            onConfirm={() => setErrorMsg('')}
          >
            {errorMsg}
          </SweetAlert>
        )}
        {successMsg && (
          <SweetAlert
            title="Registration successful!"
            success
            showConfirm
            confirmBtnBsStyle="yellow"
            onConfirm={() => navigate('/login')}
          >
                        Thank you for your registration. Your registration will be checked and approved.
          </SweetAlert>
        )}

        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="overflow-hidden">
              <div className="bg-dark mb-4 p-4">
                <Row>
                  <Col className="col-7">
                    <div className="px-4">
                      <h3 className="text-yellow mb-0">Brother TECNET</h3>
                      <p className="text-white">
                        {process.env.REACT_APP_REALM.toUpperCase()}{' '}
                                                Dealer Service Platform
                      </p>
                    </div>
                  </Col>
                  <Col className="col-5 align-self-center text-right">
                    <div className="px-4">
                      <img src={logoImg} alt="" className="img-fluid"/>
                    </div>
                  </Col>
                </Row>
              </div>
              <CardBody>
                <FormProvider {...form}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md="6">
                        <div className="form-group">
                          <Label>Firstname</Label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter firstname"
                            {...register('firstname', {required: 'Please enter your firstname'})}
                          />
                          {errors.firstname &&
                                                        <p className="text-danger">{errors.firstname.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Lastname</Label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter lastname"
                            {...register('lastname', {required: 'Please enter your lastname'})}
                          />
                          {errors.lastname && <p className="text-danger">{errors.lastname.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Position</Label>
                          <select
                            className="form-control"
                            {...register('position', {required: 'Please select a position'})}
                          >
                            <option value="">Select position</option>
                            {positions.map((pos) => (
                              <option key={pos.value} value={pos.value}>
                                {pos.label}
                              </option>
                            ))}
                          </select>
                          {errors.position &&
                                                        <p className="text-danger">{errors.position.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Company</Label>
                          <ListDealers/>
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Business Email</Label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            {...register('email', {required: 'Please enter your email'})}
                          />
                          {errors.email &&
                                                        <p className="text-danger">{errors.email.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Phone number</Label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter phone number"
                            {...register('phone', {required: 'Please enter your phone number'})}
                          />
                          {errors.phone &&
                                                        <p className="text-danger">{errors.phone.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Password</Label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Enter Password"
                            {...register('password', {
                              required: 'Please enter a password',
                              minLength: {
                                value: 6,
                                message: 'Password must be between 6 and 16 characters',
                              },
                              maxLength: {
                                value: 16,
                                message: 'Password must be between 6 and 16 characters',
                              },
                            })}
                          />
                          {errors.password &&
                                                        <p className="text-danger">{errors.password.message}</p>}
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="form-group">
                          <Label>Confirm Password</Label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Confirm Password"
                            {...register('password_confirmation', {
                              required: 'Please confirm your password',
                              validate: (value) => value === password || 'Passwords do not match',
                            })}
                          />
                          {errors.password_confirmation &&
                                                        <p className="text-danger">{errors.password_confirmation.message}</p>}
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-4">
                      <Button
                        className="btn btn-dark btn-block waves-effect waves-light"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading &&
                                                    <i className="bx bx-loader bx-spin font-size-16 align-middle mr-2"/>}
                                                Register
                      </Button>
                    </div>

                    <div className="mt-4 text-center font-size-13">
                      <p className="mb-0">By registering you agree to the{' '}
                        <a href="https://www.brother-ism.com/terms-of-use.html"
                          className="font-weight-bold text-yellow">Terms of Use
                        </a>
                      </p>
                    </div>
                  </form>
                </FormProvider>
              </CardBody>
            </Card>

            <div className="mt-5 text-center font-size-13">
              <p>Already have an account? <Link to="/login" className="font-weight-bold text-yellow">Login</Link></p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
